import { track } from '@sloyd/analytics';
import { selectors, useDispatch, useSelector } from '@sloyd/store-base';
import { useMemo } from 'react';
import { useMount } from 'react-use';
import { setBoolean } from 'shared-base';
import { ContentOffer } from './ContentOffer';

export type ContentOfferContainerProps = {};

export function ContentOfferContainer(_props: ContentOfferContainerProps) {
  const dispatch = useDispatch();
  const appState = useSelector(selectors.raw.$rawAppState);

  useMount(() => {
    track('Special Offer Viewed');
    setBoolean('specialOfferShown', true);
  });

  const callbacks = useMemo(
    () => ({
      onPlanSelect: (planId: string) => {
        track('Special Offer CTA');

        dispatch({
          type: 'PURCHASE',
          verb: 'plan',
          id: planId,
        });
      },
    }),
    []
  );

  return <ContentOffer onPlanSelect={callbacks.onPlanSelect} />;
}

export default ContentOfferContainer;
